import { Component, OnInit, Input, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { RegistrationReason, RegistrationReasonAnswer } from 'src/app/domain/ot-event';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { SelectItem } from 'src/app/shared';

@Component({
  selector: 'app-registration-reason-answer-selector',
  templateUrl: './registration-reason-answer-selector.component.html',
  styleUrls: ['./registration-reason-answer-selector.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RegistrationReasonAnswerSelectorComponent),
    multi: true
  }]
})
export class RegistrationReasonAnswerSelectorComponent implements OnInit, ControlValueAccessor {

  @Input()
  reasons: RegistrationReason[];

  options: SelectItem[];

  customReasonSelected: false;
  customReason: string;

  answers: RegistrationReasonAnswer[] = []; // this is the updated value that the class accesses
  set value(val: RegistrationReasonAnswer[]) {  // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.answers = val;
    this.onChange(val);
    this.onTouch(val);
  }
  get value(): RegistrationReasonAnswer[] {
    return this.answers;
  }

  isDisabled = false;

  @ViewChild('customReasonInput')
  private customReasonInput: ElementRef;

  constructor() { }

  onChange: any = () => { };
  onTouch: any = () => { };

  ngOnInit(): void {
    this.options = this.reasons
      ? this.reasons
        .map(reason => new SelectItem(
          reason,
          !! this.answers.find(answer => answer.answer === reason.name)))
      : [];
  }

  writeValue(value: RegistrationReasonAnswer[]): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  selectionChanged() {
    this.value = this.makeValue();
  }

  private makeValue(): RegistrationReasonAnswer[] {
    const result = this.options
      .filter(option => option.selected)
      .map(option => new RegistrationReasonAnswer(option.value.name));
    if (this.customReasonSelected) {
      result.push(new RegistrationReasonAnswer(this.customReason));
    }
    return result;
  }

  customReasonSelectionChanged() {
    if (this.customReasonSelected) {
      setTimeout(() => { this.customReasonInput.nativeElement.focus(); });
    }
  }
}
